module.exports = __webpack_public_path__ + "img/login_3.09ace6db.png";